/* eslint-disable radix */
/* eslint-disable prefer-destructuring */
/* eslint-disable eqeqeq */
/* eslint-disable react/no-array-index-key */
/* eslint-disable array-callback-return */
/* eslint-disable arrow-body-style */
/* eslint-disable no-unused-vars */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
// eslint-disable-next-line operator-assignment, prefer-template
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, withStyles } from "@material-ui/core/styles";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import MuiTableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import styles from './TableSimple.module.css';

const useStyles = makeStyles({
    table: {
       minWidth: "max-content",
        "& .MuiTableCell-root": {
            border: "1px solid rgba(224, 224, 224, 1)",
        },
        "& .MuiTableCell-sizeSmall" : {
            padding: "6px 5px 6px 5px",
          }
    }
});



const TableSimple = ({ tableColumnData, tableHeaderLabel, TableRowHederAling,size,headerColor, bookingTable }) => {
    const classes = useStyles();
// Changes Start for CHG0073013    
    const tableHeader = tableHeaderLabel.map((label, index) => {
        if (typeof label === 'object' && label !== null) {
          return (
            <TableCell
              key={`header-${index}`}
              width={label.width || 'auto'}
              align={TableRowHederAling}
              className={styles.tableheaderFont}
            >
              {label.component || label.label}
            </TableCell>
          );
        }
      
        const myArray = label.split('_');
      
        let wd = 'auto';
        let labelText;
      
        if (myArray.length === 2) {
          wd = `${parseInt(myArray[1], 10)}px`;
          labelText = myArray[0];
        } else {
          labelText = label;
        }
      
        return (
          <TableCell
            key={`header-${index}`}
            width={wd}
            align={TableRowHederAling}
            className={styles.tableheaderFont}
          >
            {labelText}
          </TableCell>
        );
      });
// Changes Start for CHG0073013     
    const tableRow = tableColumnData?.map((row,id) => {
        return (<TableRow  key={`pratik${id}`} size={size} style={{overflowX:"visible"}}> 
            {Object.entries(row).map(([lable, value], idx) => ( 
                <TableCell align={TableRowHederAling} className={styles.table_cell}>
                    {value}
                </TableCell>
            ))
            }
        </TableRow>)
    });
    const TableHead = withStyles((theme) => ({
        root: {
            backgroundColor: headerColor,
            overflowX:"visible",
        }
    }))(MuiTableHead);
    // console.log(tableRow.length,"tableRow.length");
    return (
        <>
         <TableContainer
           style={{overflowX:"visible", width: "100%" }}
        
        >
            {/* <Table className={classes.table} size={tableRow.length>=2?size:size} aria-label="a dense table"> */}
            <Table className={bookingTable ? classes.tableFontSize : classes.table} size={size} aria-label="a dense table">
                <TableHead>
                    <TableRow style={{ width: 100 }}>
                        {tableHeader}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {tableRow}
                </TableBody>
                           </Table>        
        </TableContainer>
         {/* <div style={{background:"blue",margin:"0px",padding:"0px",borderRadius:"5px",height:"10px",color:"blue",fontSize:"1px",overflowX:"10px"}}>
           t
         </div> */}
        </>
       
    );
};

TableSimple.propTypes = {
    tableColumnData: PropTypes.array,
    tableHeaderLabel: PropTypes.array,
    TableRowHederAling: PropTypes.string,
    size: PropTypes.string,
    headerColor: PropTypes.string,


};

export default TableSimple;